<template>
    <div class="supply_wrap2">
        <div class="search-wrap" :class="{'dropdown':!dropdown}" :style="{height: H}" id="search_top_con">
            <!-- 搜索条件 -->
            <div style=" margin: 0 auto;">
                <div class="search-box1">
                    <div class="suppldetaibox-top">
                        <div style="width:94px ;">
                            <el-select v-model="form.status" class="mySelect" popper-class="wentipingSelectPopper"
                                @change="handleSelectChange" style="width: 94px; margin-right: 20px;">
                                <el-option v-for="item in statusList" :key="item.value" :value="item.value"
                                    :label="item.label"></el-option>
                            </el-select>
                        </div>
                        <div style="flex: 1;">
                            <div v-if="form.status == 0" style="display:flex ; align-items: center;">
                                <el-input style="position:relative ;" v-model="tempform.isbns" placeholder="可输入多个ISBN"
                                    readonly @click.native="multiplePop('ISBN','isbns')">
                                </el-input>
                                <i v-if="tempform.isbns" class="el-icon-circle-close circleclose"
                                    style="position: absolute ; right: 70px;" @click="clearValue('isbns')"></i>
                            </div>
                            <div v-if="form.status == 1" style="display:flex; align-items: center;">
                                <el-input v-model="tempform.bookname" placeholder="请输入书名" clearable>
                                </el-input>
                            </div>
                            <div v-if="form.status == 2" style="display:flex; align-items: center;">
                                <el-input placeholder="请输入作者" v-model="tempform.author" clearable>
                                </el-input>
                            </div>
                        </div>
                        <div class="titleNames"></div>
                    </div>
                    <el-form label-position="right" label-width="90px" :model="tempform" style="width:95%;">
                        <el-row>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="出版社：" style="font-weight: 700; " class="labelwrap"
                                    v-if="showpubname">
                                    <el-input v-model="tempform.pubname" placeholder="输入搜索条件" readonly
                                        @click.native="pubpop(tempform.pubname)" style="height: 35px;">
                                    </el-input>
                                    <i v-if="tempform.pubname" class="el-icon-circle-close circleclose"
                                        @click="clearValue('pubname','','pubid')"></i>
                                </el-form-item>
                            </el-col>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="中图法：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.ztf" placeholder="选择中图分类" readonly
                                        @click.native="ztfflWindow()">
                                    </el-input>
                                    <i v-if="tempform.ztf" class="el-icon-circle-close circleclose"
                                        @click="clearValue('ztf','classifydata')"></i>
                                </el-form-item>
                            </el-col>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="学科分类：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.subjectShow" readonly placeholder="选择学科分类"
                                        @click.native="styClass()">
                                    </el-input>
                                    <i v-if="tempform.subjectShow" class="el-icon-circle-close circleclose"
                                        @click="clearValue('subjectShow','xuekedata','xkfl')"></i>
                                </el-form-item>
                            </el-col>
                            <el-col :span="showpubname?'6':'8'">
                                <el-form-item label="大众分类：" style="font-weight: 700;" class="labelwrap">
                                    <el-input v-model="tempform.dazhongshow" placeholder="选择大众分类" readonly
                                        @click.native="pubClass()">
                                    </el-input>
                                    <i v-if="tempform.dazhongshow" class="el-icon-circle-close circleclose"
                                        @click="clearValue('dazhongshow','dazhongdata','dzfl')"></i>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :span="24">
                            <el-col :span="9">
                                <el-form-item label="出版时间：" style="font-weight: 700;">
                                    <div style="display: flex; align-items: center;">
                                        <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd"
                                            style="width: 100%;" :picker-options="startTime" v-model="tempform.pubfrom">
                                        </DatePicker>
                                        <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                        <DatePicker type="month" placeholder="选择日期" value-format="yyyy-MM-dd"
                                            style="width: 100%;" :picker-options="endTime" v-model="tempform.pubto">
                                        </DatePicker>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="码洋：" style="font-weight: 700;">
                                    <div style="display: flex; align-items: center;">
                                        <el-input v-model="tempform.myfrom" clearable style="width: 85px;"></el-input>
                                        <i class="font"
                                            style="font-weight: normal; font-style: normal; margin-left: 5px;">元</i>
                                        <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                        <el-input v-model="tempform.myto" clearable style="width: 85px;"></el-input>
                                        <i class="font"
                                            style="font-weight: normal; font-style: normal; margin-left: 5px;">元</i>
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="7">
                                <el-form-item label="尺寸：" style="font-weight: 700;">
                                    <div style="display: flex; align-items: center;">
                                        <el-input v-model="tempform.min" clearable style="width: 85px;"></el-input>
                                        <i class="font"
                                            style="font-weight: normal; font-style: normal; margin-left: 5px;">cm</i>
                                        <el-col class="line" :span="4" style="text-align: center;">-</el-col>
                                        <el-input v-model="tempform.max" clearable style="width: 85px;"></el-input>
                                        <i class="font"
                                            style="font-weight: normal; font-style: normal; margin-left: 5px;">cm</i>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <div v-show="showAdditionalSearch" id='toggle-btn'>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="适用对象：" style="font-weight: 700;">
                                        <div class="flex-container">
                                            <div v-for="(item, index) in objArr" :key="index" class="flex-item"
                                                @click="toggleSelected1(index)"
                                                :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                                {{ item.value }}
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="装帧：" style="font-weight: 700;">
                                        <div class="flex-container">
                                            <div v-for="(item, index) in zzArr" :key="index" class="flex-item"
                                                @click="toggleSelected2(index)"
                                                :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                                {{ item.value }}
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="阅读类型：" style="font-weight: 700;">
                                        <div class="flex-container">
                                            <div v-for="(item, index) in readbooktype" :key="index" class="flex-item"
                                                @click="toggleSelected3(index)"
                                                :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                                {{ item.key }}
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24">
                                    <el-form-item label="交付方式：" style="font-weight: 700;">
                                        <div class="flex-container">
                                            <div v-for="(item, index) in Paymentmethod" :key="index" class="flex-item"
                                                @click="toggleSelected4(index)"
                                                :class="{ 'flex-item-14': true, 'selected': item.selected }">
                                                {{ item.key }}
                                            </div>
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                        <!--  -->
                        <div class="search-btn" v-show="dropdown">
                            <Button type="primary" size="mini" @click="onSubmit" class="submit-btn">检索</Button>
                            <Button @click.native="resetForm" size="mini"
                                class="iconfont icon-reset reset-btn">重置</Button>
                        </div>
                    </el-form>
                </div>
            </div>
            <span class="drop_btn" @click="toggleSlide(500)" id='toggle-btn'
                :class="{'el-icon-top':showAdditionalSearch,'el-icon-bottom':!showAdditionalSearch}">{{showAdditionalSearch?
                '收起':'展开更多'}}检索条件</span>
        </div>
        <div>
            <div class="zjdBg" v-if="isBeat && (adminState == 0 || adminState == 1)">
                <div class="zjdContent">
                    <div class="q">
                        <div class="zjd">
                            <img src="../assets/images/zjdbj.jpg" alt="">
                            <!-- <marquee class="zjdtime" direction=left>
                                活动时间为：2022年9月19日到2022年9月20日的每天上午的10点到10点10分，下午的15点到15点10分。
                            </marquee> -->
                            <!-- <div class='hdcc1'>
                                <p class='hdcc'> 活动场次</p>
                                <div v-for="(item,index) in c" :key="index">{{item.start_time}}--{{item.end_time}}</div>
                            </div> -->
                            <div class="zjdClose" @click="zjdClose">
                                <img src="../assets/zjd_img/quit.png" />
                            </div>
                            <div class="nostate" v-if="how">
                                活动还未开始敬请期待！
                            </div>
                            <div class="zjdBox" v-else style="position:absolute ; top: 0;">
                                <zjd-component :activateinfo="activateInfo" :activatesource='activatesource'
                                    :activateid='activateid'>
                                </zjd-component>
                            </div>
                            <div class="prInfo">
                                <div class="prInfo-box">
                                    <div class="prInfo-info">中奖明细</div>
                                </div>
                                <div id="moocBox"  style="height: 300px; overflow: auto;" @mouseover="stopScroll" @mouseout="startScroll">
                                    <ul id="con1">
                                        <li v-for="(item,index) in listname" :key="index"
                                            style="line-height: 40px; color: #1a0707; font-size: 14px; ">恭喜
                                            <a href="#" style="color:red;">{{item.org_name}}</a>获得<a href="#"
                                                style="color:red;">{{item.level}}</a>
                                        </li>
                                    </ul>
                                    <!-- <ul id="con2">
                                        <li v-for="(item,index) in listname" :key="index"
                                            style="line-height: 40px; color: #1a0707; font-size: 14px;">恭喜
                                            <a href="#" style="color:red;">{{item.org_name}}</a>获得<a href="#"
                                                style="color:red;">{{item.level}}</a>
                                        </li>
                                    </ul> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div style="position:absolute ; top: 230px;left: 20px;" v-if="showzajindan && (adminState == 0 || adminState == 1)">
            <!-- <div style="position:absolute ; top: 230px;left: 20px;" v-if="true"> -->

            <img src="../assets/pub_img/daojishuawen.png" alt="" style="width: 210px; height: 150px; position: relative;">
            <div v-if="!newRecodePop"
                style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center; position: absolute;  top: 0px; height: 100%; width: 100%;">
                <div style="color: #fff;font-size: 20px;font-weight: 700;">砸金蛋,赢大礼</div>
                <div v-if="showactivity">
                    <!-- <div v-if="true"> -->

                    <div style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;"
                        v-if="dianclose">
                        <!-- <div style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;"
                        v-if="true"> -->

                        <div style="color: #fff;font-size: 20px;font-weight: 700;">倒计时: <span style="color: #FFD700;">
                                {{ formattedTime }}</span> </div>
                        <div style="color: #fff; font-size: 14px;">(退出该页面后倒计时将重置)</div>
                    </div>
                    <div style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;"
                        v-else @click="zajindan">
                        <div style="color: #fff; font-size: 20px; font-weight: 700; cursor: pointer;">
                            <span v-for="(letter, index) in text" :key="index"
                                :style="{ animationDelay: `${index * 0.5}s` }" class="jump-text">{{ letter }}</span>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div v-if="showstart"
                        style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center;">
                        <div style="color: #fff;font-size: 20px;font-weight: 700;">活动未开始</div>
                        <div style="color: #fff; font-size: 14px;"> 开始时间为:({{ starttimekaishi}})</div>
                    </div>
                    <div v-else>
                        <div style="color: #fff;font-size: 20px;font-weight: 700;">活动已结束</div>
                    </div>
                </div>
            </div>
            <div v-else
                style="display: flex; justify-content: space-evenly; flex-direction: column; align-items: center; position: absolute;  top: 0px; height: 100%; width: 100%; ">
                <div style="color: #fff;font-size: 20px;font-weight: 700;">砸金蛋,赢大礼</div>
                <div
                    style="color: #fff; display: flex; justify-content:center; flex-direction: column; align-items: center; font-weight: 700;">
                    <div v-if="ishuode">恭喜您获得</div>
                    <div style="color: #FFD700;font-size: 18px; width: 81%;">{{present_name}}</div>
                </div>
                <a href="javascript:;" class="bottxtx" @click="getWinning()"> <span
                        style="color: #fff;">【领取礼品】</span></a>
            </div>
        </div>
        <!-- 倒计时/集卡成功显示 -->
        <div class="countdown" :class="{ 'swing1-animation': isCompleted }" @click="handleCountdownClick" v-if="showjika && adminState == 1">
            <div v-if="!isCompleted" class="timer">
                <div class="card-icon">📇集卡赢大奖</div>
                <div class="timer-text">{{ jikaformattedTime }}</div>
                <div class="collecting-text">(退出页面后倒计时将重置)</div>
            </div>
            <div v-else>
                <div class="success-badge">
                    🎉 集卡成功!
                </div>
                <div class="collection-record" @click.stop="gomycardcollecting">
                    <span class="record-icon">📜</span>
                    <span class="record-text">我的集卡</span>
                </div>
            </div>
        </div>
        <!-- 集卡弹窗 -->
        <div v-if="dialogVisible" class="dialog-mask">
            <div class="custom-dialog">
                <div class="dialog-header">
                    <span class="dialog-title">🎉 集卡成功</span>
                    <button class="close-btn" @click="dialogVisible = false">×</button>
                </div>
                <div class="dialog-body">
                    <!-- 彩带粒子 -->
                    <div class="confetti">
                        <div v-for="(confetti, index) in confettis" :key="'confetti'+index" class="confetti-piece"
                            :style="confetti.style"></div>
                    </div>

                    <div class="card-container">
                        <!-- 旋转特效 -->
                        <template v-if="isFirstTime">
                            <img v-for="(img, index) in rotatingImages" :key="index" :src="img" class="rotating-card"
                                :style="getCardStyle(index)" />
                        </template>

                        <!-- 最终展示图片 -->
                        <img v-show="showFinalImage" :src="cardimageUrl" class="final-card" />
                    </div>

                    <div class="congratulations-text">
                        <span class="text-with-light">🎊 {{suppliercardName}}恭喜您集卡成功！</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Row, Col, Form, FormItem, Input, Button, Notification, Checkbox, DatePicker, CheckboxGroup, Select, Option } from 'element-ui'
    import classifyPop from './ClassifyPop'
    import studyclass from './studyClassPop'
    import publicpop from './publicPop'
    import ZjdComponent from "./testcopy";
    import Axios from "@/api/diyaxios";
    import popup from '../common/plugin/dialog/index.js'
    import pubDialog from './pubDialog'
    import keyValuePop from './textareaDialog'
    import Cookies from 'js-cookie'
    import { insertPoint } from '@/api/insertPoints'   //添加埋点
    import { goldeggsmashingactivity, goldeggsids } from '@/api/pages'
    import { showconsolidationcard, cardcollectionsuccessful } from '@/api/mycardcollecting.js'

    export default {
        props: ['isShowType', 'showpubname', 'activityID'],
        data() {
            let vm = this;
            return {
                cardimageUrl: '',
                suppliercardName: '',
                showzajindan: false,   //进入倒计时的提示显示和隐藏  砸金蛋开关 有活动为true 没有活动就false
                showAdditionalSearch: false,
                text: "点我砸金蛋",
                dianclose: true,
                countdownTime: 180,
                // countdownTime: 10,

                timer: null,
                startTime: null,
                pubShow: true,
                zttagShow: true,
                ztfShow: true,
                xkShow: true,
                dzShow: true,
                dropdown: true,//是否展开
                H: this.showAdditionalSearch ? `590px` : `300px`,
                // 适用对象
                objArr: [
                    { key: '', value: '全部', selected: false },
                    { key: '本科及以上', value: '本科及以上', selected: false },
                    { key: '高职', value: '高职', selected: false },
                    { key: '少儿', value: '少儿', selected: false },
                    { key: '音像电子', value: '音像电子', selected: false },
                    { key: '中职', value: '中职', selected: false },
                    { key: '职业教育', value: '职业教育', selected: false },
                    { key: '成人教育', value: '成人教育', selected: false },
                    { key: '幼儿', value: '幼儿', selected: false },
                    { key: '小学', value: '小学', selected: false },
                    { key: '初中', value: '初中', selected: false },
                    { key: '中小学', value: '中小学', selected: false },
                    { key: '高中', value: '高中', selected: false },
                    { key: '青少年', value: '青少年', selected: false },
                    { key: '通俗读物', value: '通俗读物', selected: false },
                    { key: '继续教育', value: '继续教育', selected: false }
                ],
                zzArr: [//装帧
                    { key: '', value: '平装', selected: false },
                    { key: '精装', value: '精装', selected: false },
                    { key: '线装', value: '线装', selected: false },
                    { key: '活页', value: '活页', selected: false },
                    { key: '其它', value: '其它', selected: false },
                    { key: '函装', value: '函装', selected: false },
                    { key: '盒装', value: '盒装', selected: false }
                ],
                readbooktype: [//阅读类型
                    { key: '纸质书', value: '1', selected: false },
                    { key: '纸电同步', value: '2', selected: false },
                    { key: '期刊', value: '4', selected: false },
                ],
                Paymentmethod: [//支付方式
                    { key: '全部', value: '', selected: false },
                    { key: '期货', value: '0', selected: false },
                    { key: '现货', value: '1', selected: false },
                ],
                statusList: [
                    {
                        value: '0',
                        label: 'ISBN'
                    },
                    {
                        value: '1',
                        label: '书名'
                    },
                    {
                        value: '2',
                        label: '作者'
                    },
                ],
                form: {
                    status: '0'
                },
                tempform: {//表单信息
                    // goodstype:1,
                    isbns: null,
                    bookname: null,
                    author: null,
                    pubname: null,
                    pubid: null,
                    pubfrom: null,
                    pubto: null,
                    ztf: null,
                    subjectShow: null,
                    xkfl: null,
                    dazhongshow: null,
                    dzfl: null,
                    myfrom: null,
                    myto: null,
                    useobj: null,
                    zhuangj: null,
                    activitytag: null,
                    isaddcar: '0',
                    delivery: null,
                    goodsType: null,
                    // size: 20,
                    // current: 1
                },
                m_modal: null,
                classifydata: null,
                temp_pop: null,
                pub_pop: null,
                key_pop: null,
                savetemp_pop: null,
                sty_clsss: null,
                public_clsss: null,
                xuekedata: null,
                dazhongdata: null,
                pubObjCheck: [],//出版社选中数据
                startTime: {
                    disabledDate: time => {
                        if (vm.tempform.pubto) {
                            return (
                                time.getTime() > new Date(vm.tempform.pubto).getTime()
                            );
                        }
                    }
                },
                endTime: {
                    disabledDate: time => {
                        if (vm.tempform.pubfrom) {
                            return (
                                time.getTime() < new Date(vm.tempform.pubfrom).getTime()
                            );
                        }
                    }
                },
                listname: [],
                msg: '恭喜您中奖了',
                isBeat: false, //砸金蛋弹窗
                isAble: false, //禁用按钮
                activateInfo: "", //活动信息
                activatesource: '',
                activateid: '',
                success: "",
                istimer: null,
                ishuode: false,
                timelist: [
                    { start: "2022-09-23 15:00:00", end: "2022-09-23 15:10:00" },
                    { start: "2022-09-23 10:00:00", end: "2022-09-23 10:10:00" },

                    { start: "2022-09-22 15:00:00", end: "2022-09-22 15:10:00" },
                    { start: "2022-09-22 10:00:00", end: "2022-09-22 10:10:00" },

                    { start: "2022-09-21 15:00:00", end: "2022-09-21 15:10:00" },
                    { start: "2022-09-21 10:00:00", end: "2022-09-21 10:10:00" },

                    { start: "2022-09-20 15:00:00", end: "2022-09-20 15:10:00" },
                    { start: "2022-09-20 10:00:00", end: "2022-09-20 10:10:00" },

                    { start: "2022-09-19 15:00:00", end: "2022-09-19 18:00:00" },
                    { start: "2022-09-19 10:00:00", end: "2022-09-19 10:10:00" },
                ],
                speed: 50,
                myScroll: null,
                showToast: false, //显示中奖弹窗
                showstatus: false,  //砸金蛋状态
                //砸金蛋结果
                winResult: null,
                how: false,
                imaguls: '',
                levels: '',
                showsta: false,
                newRecodePop: false,
                present_name: '',
                huodongchangci: [],
                showactivity: false,
                showstart: false,
                starttimekaishi: '',


                // 集卡data
                showjika:false,
                confettis: [],
                starCount: 30,
                confettiCount: 20,
                remainingTime: 300, // 总倒计时秒数（示例为10秒）
                // remainingTime: 5, // 总倒计时秒数（示例为10秒）
                isCompleted: false,
                dialogVisible: false,
                isFirstTime: true,
                rotatingImages: [],
                finalImage:'',
                showFinalImage: false,
                adminState: Cookies.get("adminState"),

            }
        },
        components: {
            Row, Col, Form, FormItem, Input, Button, Notification, Checkbox, DatePicker, CheckboxGroup, Select, Option, ZjdComponent,
        },
        created() {
            this.startTime = new Date();
            if(this.adminState ==0 || this.adminState ==1 ){
                this.getWinningRecord()  // 查询个人中没中奖
                this.getJindan()   // 查询所有中奖记录
            }
            this.form.status = this.statusList[0].value;
            this.objArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.useobj = item.key
                } else {
                    item.selected = false;
                }
            });
            this.zzArr.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.zhuangj = item.key
                } else {
                    item.selected = false;
                }
            });
            this.Paymentmethod.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.delivery = item.value


                } else {
                    item.selected = false;
                }
            });
            this.readbooktype.forEach((item, index) => {
                if (index === 0) {
                    item.selected = true;
                    this.tempform.goodsType = item.value

                } else {
                }
            });
        },
        mounted() {
            let vm = this
            if (vm.$route.name === "calendar") {
                vm.isAble = true;
            }
            vm.$nextTick(() => {
                const area = document.getElementById('moocBox');
                const con1 = document.getElementById('con1');
                // const con2 = document.getElementById('con2');
                area.scrollTop = 0;
                // con2.innerHTML = con1.innerHTML;
                vm.myScroll = setInterval(vm.scrollUp, vm.speed);
                let isType = vm.isShowType;
                for (var key in isType) {
                    vm[key] = isType[key];
                }
            })
            // 集卡倒计时
            let rp = JSON.parse(vm.$route.query.obj);
            if ((rp.gid || rp.pubid) && vm.adminState == 1) {
             vm.getshowconsolidationcard();
            } 
        },
        destroyed() {
            clearInterval(this.istimer);
        },
        computed: {
            formattedTime() {
                return this.formatTime();
            },
            jikaformattedTime() {
                const hours = Math.floor(this.remainingTime / 3600); // 计算小时
                const minutes = Math.floor((this.remainingTime % 3600) / 60); // 计算分钟
                const seconds = this.remainingTime % 60; // 计算秒数
                return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
            },

        },
        beforeDestroy() {
            const endTime = new Date();
            const timeSpent = (endTime - this.startTime) / 1000;
            if (timeSpent < this.countdownTime) {
                this.resetTimer();
            } else {
                console.log("User stayed on the page for 5 minutes");
            }
        },
        methods: {

            startTimer() {
                this.timer = setInterval(() => {
                    this.countdownTime--;
                    if (this.countdownTime <= 0) {
                        clearInterval(this.timer);
                        this.isBeat = true
                        this.startScroll()
                        if (this.showAdditionalSearch) {
                            this.toggleSlide(500)
                        }
                    }
                }, 1000);
            },
            resetTimer() {
                clearInterval(this.timer);
                this.countdownTime = 300;
                this.startTimer();
            },
            formatTime() {
                const minutes = Math.floor(this.countdownTime / 60);
                const seconds = this.countdownTime % 60;
                return `${minutes.toString().padStart(2, '0')}分${seconds.toString().padStart(2, '0')}秒`;
            },
            stopScroll() {
                clearInterval(this.myScroll);
            },
            startScroll() {
                this.myScroll = setInterval(this.scrollUp, this.speed);
            },
            scrollUp() {
                const area = document.getElementById('moocBox');
                const con1 = document.getElementById('con1');
                // const con2 = document.getElementById('con2');
                if (area.scrollTop >= 100) {
                    area.scrollTop = 0;
                } else {
                    area.scrollTop++;
                }
            },

            toggleSelected1(index) {
                this.objArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.useobj = item.key
                        console.log('选中的值1为：', item.value);
                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected2(index) {
                this.zzArr.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        console.log('选中的值2为：', item.value);
                        this.tempform.zhuangj = item.key
                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected3(index) {
                this.readbooktype.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.goodsType = item.value
                        console.log('选中的值3为：', item.value);
                    } else {
                        item.selected = false;
                    }
                });
            },
            toggleSelected4(index) {
                this.Paymentmethod.forEach((item, i) => {
                    if (i === index) {
                        item.selected = true;
                        this.tempform.delivery = item.value
                        console.log('选中的值4为：', item.value);

                    } else {
                        item.selected = false;
                    }
                });
            },
            handleSelectChange(value) {
                this.form.status = value
                console.log('当前选中的值是：', value);
            },
            //弹开收起
            toggleSlide(s) {
                // let vm = this,
                //     div = document.getElementById('search_top_con');
                // div.style.transition = 'height ' + s + 'ms';
                // vm.dropdown = !vm.dropdown;
                // if (vm.dropdown) vm.H = `560px`; else vm.H = `25px`
                this.toggleAdditionalSearch(s)
            },
            toggleAdditionalSearch(s) {
                let vm = this,
                    div = document.getElementById('search_top_con');
                div.style.transition = 'height ' + s + 'ms';
                this.showAdditionalSearch = !this.showAdditionalSearch;
                if (this.showAdditionalSearch) this.H = `590px`; else this.H = `300px`
            },
            zajindan() {
                this.isBeat = true;
            },
            iSlogin() {
                return Cookies.get('token') ? true : false;
            },
            //检索
            onSubmit() {
                let vm = this,
                    queryFormData = {};
                queryFormData = JSON.parse(JSON.stringify(vm.tempform));
                let isbns = queryFormData.isbns,
                    activitytag = queryFormData.activitytag;
                if (isbns && isbns != '') queryFormData.isbns = isbns.replace(/-/g, '');
                if (activitytag && activitytag.length > 0) queryFormData.activitytag = activitytag.join(','); else queryFormData.activitytag = '';
                delete queryFormData.subjectShow;
                delete queryFormData.dazhongshow;
                let doId = +localStorage.getItem('doId') + 1;
                localStorage.setItem('doId', doId);
                insertPoint(queryFormData, 'click', 'search', doId); //添加“高级检索”埋点

                vm.$emit('submitForm', queryFormData);
            },
            //清除
            clearValue(prop, val, data) {
                let vm = this;
                vm.tempform[prop] = null;
                if (val) vm[val] = null;
                if (data) vm.tempform[data] = null;
            },
            //重置
            resetForm() {
                let vm = this;
                vm.classifydata = null;
                vm.xuekedata = null;
                vm.dazhongdata = null;
                vm.tempform.xkfl = null;
                vm.tempform.dzfl = null;
                vm.tempform.pubid = null;
                vm.tempform.isbns = null;
                vm.tempform.bookname = null;
                vm.tempform.myfrom = null;
                vm.tempform.myto = null;
                vm.tempform.author = null;
                vm.tempform.pubname = null;
                vm.tempform.ztf = null;
                vm.tempform.subjectShow = null;
                vm.tempform.dazhongshow = null;
                vm.tempform.pubfrom = null;
                vm.tempform.pubto = null;
                vm.tempform.min = null;
                vm.tempform.max = null;
                this.objArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.useobj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.zzArr.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.zhuangj = item.key
                    } else {
                        item.selected = false;
                    }
                });
                this.Paymentmethod.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.delivery = item.value


                    } else {
                        item.selected = false;
                    }
                });
                this.readbooktype.forEach((item, index) => {
                    if (index === 0) {
                        item.selected = true;
                        this.tempform.goodsType = item.value

                    } else {
                    }
                });
                console.log(vm.tempform, 'vm.tempform重置');
                // vm.$refs.tempform.resetFields();
            },
            //中图法
            ztfflWindow() {
                let vm = this;
                vm.m_modal = popup('<classify-pop @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '中图法分类',
                        width: '800px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.classifydata
                            }
                        },
                        components: {
                            classifyPop
                        },
                        methods: {
                            submit(data) {
                                let str = String(data.msgCode);
                                vm.$set(vm.tempform, 'ztf', str);
                                vm.classifydata = data.dataStr;
                                vm.m_modal.hide();
                            },
                            close(data) {
                                vm.m_modal.hide();
                            }
                        }
                    }
                });
                vm.m_modal.show();
            },
            //学科分类
            styClass() {
                let vm = this;
                vm.sty_clsss = popup('<studyclass @close="close" @ok="submit" :msg="msg"/>', {
                    option: {
                        title: '学科分类',
                        width: '630px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.xuekedata
                            }
                        },
                        components: {
                            studyclass
                        },
                        methods: {
                            submit(data) {
                                vm.xuekedata = data;
                                let arr = data.split('|');
                                vm.tempform.subjectShow = arr[1];
                                vm.tempform.xkfl = arr[0];
                                vm.sty_clsss.hide();
                            },
                            close(data) {
                                vm.sty_clsss.hide();
                            }
                        }
                    }
                });
                vm.sty_clsss.show();
            },
            //大众分类
            pubClass() {
                let vm = this;
                vm.public_clsss = popup('<publicpop @close="close" @ok="submit" :msg="msg" :search="0" :datatype="3"/>', {
                    option: {
                        title: '大众分类',
                        width: '600px',
                        height: '560px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.dazhongdata
                            }
                        },
                        components: {
                            publicpop//中图组件
                        },
                        methods: {
                            submit(data) {
                                console.log(data, '大众分类');
                                vm.dazhongdata = data;
                                let arr = data.split('|');
                                vm.tempform.dazhongshow = arr[1];
                                vm.tempform.dzfl = arr[0];
                                vm.public_clsss.hide();
                            },
                            close(data) {
                                vm.public_clsss.hide();
                            }
                        }
                    }
                });
                vm.public_clsss.show();
            },
            //出版社
            pubpop() {
                let vm = this;
                vm.pub_pop = popup('<pub-dialog @close="close" :msg="msg" @ok="submit" />', {
                    option: {
                        title: '出版社选择',
                        width: '630px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: vm.pubObjCheck
                            }
                        },
                        components: {
                            pubDialog
                        },
                        methods: {
                            submit(data) {
                                vm.tempform.pubname = data.pubname;
                                // console.log(vm.tempform.pubname,'vm.tempform.pubname')
                                // vm.tempform.pubid = data.pubid;
                                data.choosedData.forEach(element => {
                                    vm.pubObjCheck.push(element.orgName)
                                });
                                vm.pub_pop.hide();
                            },
                            close(data) {
                                vm.pub_pop.hide();
                            }
                        }
                    }
                })
                vm.pub_pop.show();
            },
            //关键词
            multiplePop(txt, flag) {
                let vm = this,
                    val = '';
                val = vm.tempform[flag];
                vm.key_pop = popup('<key-value-pop @close="close" @ok="submit" :msg="msg" />', {
                    option: {
                        title: `多个${txt}批量查询`,
                        width: '336px'
                    },
                    popup: {
                        data() {
                            return {
                                msg: {
                                    val: val,
                                    flag: flag
                                }
                            }
                        },
                        components: {
                            keyValuePop
                        },
                        methods: {
                            submit(data) {
                                let flag = data.flag;
                                vm.tempform[flag] = data.val;
                                vm.key_pop.hide();
                            },
                            close() {
                                vm.key_pop.hide();
                            }
                        }
                    }
                })
                vm.key_pop.show();
            },

            //获取活动状态
            // getActiveStatue(now) {
            //     let vm = this,
            //         lastTime = new Date(
            //             vm.timelist[vm.timelist.length - 1].end
            //         ).getTime(); //活动最后一场时间戳
            // },
            zjdClose() {
                let vm = this;
                vm.isBeat = false;
                if (Cookies.get('token')) {
                    Axios.post('/gold/activate/ugetrecordlist', {
                        params: {
                            selecttj: 'gold_activate_record.user_id=' + Cookies.get("UserID"),
                            ordertj: '',
                            pageSize: 100,
                            pageNum: 1,
                            userid: Cookies.get("UserID"),
                            activateid: vm.activateid
                        }
                    }, {
                        headers: {
                            "Content-Type": "application/json",
                            token: Cookies.get('token')
                        }
                    }
                    ).then(res => {
                        if (res.status) {
                            if (res.data.list.length > 0) {

                                vm.levels = res.data.list[0].level
                                vm.present_name = res.data.list[0].present_name
                                if (vm.levels == '4等奖') {
                                    vm.ishuode = false
                                } else {
                                    vm.ishuode = true
                                }
                                vm.newRecodePop = true; //显示中奖纪录
                                vm.stopScroll()
                                vm.newRecodePop = true; //显示中奖纪录
                                vm.dianclose = true
                            } else {
                                vm.stopScroll()

                                vm.newRecodePop = false;
                                vm.dianclose = false

                            }
                        }
                    }).catch(err => {

                    });
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            //获取举行砸金蛋活动的供应商（出版社）信息
            // getNowActiveInfo() {
            //     let vm = this;
            //     if (Cookies.get("token")) {
            //         Axios.post("/gold/activate/getnowactivate", {
            //             params: {
            //                 userid: Cookies.get("UserID"),
            //             },
            //         }, {
            //             headers: {
            //                 "Content-Type": "application/json",
            //                 token: Cookies.get("token"),
            //             },
            //         }).then((res) => {
            //             if (res.status) {
            //                 //判断是否是供应商列表页面，且是当前供应商（出版社）
            //                 if (vm.$route.query.obj) {
            //                     let rp = JSON.parse(vm.$route.query.obj);
            //                     //是否为出版社(供应商)书目列表页面
            //                     if (
            //                         vm.$route.name ==
            //                         "LookPublishingPagesType" &&
            //                         rp[res.data.datatype] == res.data.org_name
            //                     ) {
            //                         //如果是
            //                         if (rp.gid != "0") {
            //                             if (res.data.isjoin == 0) {
            //                                 vm.isBeat = true;
            //                                 vm.isjieguo = false;
            //                             } else {
            //                                 vm.isjieguo = true;
            //                                 vm.isBeat = false;
            //                             }
            //                         }
            //                         if (rp.isHandleBeat == "0") {
            //                             vm.isjieguo = true;
            //                             vm.isBeat = false;
            //                         }
            //                     } else {
            //                         //否则跳转到 出版社(供应商)书目列表页面LookPublishingPagesType
            //                         let params = {
            //                             isHandleBeat: 1, //是否是点击“砸金蛋”进入标识
            //                             goodsType: 1,
            //                             eventId: "ad1000",
            //                         };
            //                         params[res.data.datatype] =
            //                             res.data.org_name;
            //                         vm.$router.push({
            //                             name: "LookPublishingPagesType",
            //                             query: { obj: JSON.stringify(params) },
            //                         });
            //                     }
            //                 } else {
            //                     //否则跳转到 出版社(供应商)书目列表页面LookPublishingPagesType
            //                     let params = {
            //                         isHandleBeat: 1, //是否是点击“砸金蛋”进入标识
            //                         goodsType: 1,
            //                         eventId: "ad1000",
            //                     };
            //                     params[res.data.datatype] = res.data.org_name;
            //                     vm.$router.push({
            //                         name: "LookPublishingPagesType",
            //                         query: { obj: JSON.stringify(params) },
            //                     });
            //                 }
            //                 //获取活动id
            //                 vm.activateInfo = res.data;
            //             } else {
            //                 if (res.code == "1000") {
            //                     vm.$alert(res.msg, "温馨提示", {
            //                         confirmButtonText: "确定",
            //                     });
            //                 } else if (res.code == "2000") {
            //                     let params = {
            //                         isHandleBeat: 0, //是否是点击“砸金蛋”进入标识
            //                         goodsType: 1,
            //                         eventId: "ad1000",
            //                     };
            //                     params[res.data.datatype] = res.data.org_name;
            //                     vm.$router.push({
            //                         name: "LookPublishingPagesType",
            //                         query: { obj: JSON.stringify(params) },
            //                     });
            //                 }
            //             }
            //         }).catch((err) => {
            //             vm.$alert(err.msg, "温馨提示", {
            //                 confirmButtonText: "确定",
            //             });
            //         });
            //     } else {
            //         this.$router.push({ name: "Login" });
            //     }
            // },

            //查询中奖纪录
            async getWinningRecord() {
                let vm = this;
                if (Cookies.get('token')) {
                    // 查询活动场次
                    let data = {
                        userid: Cookies.get('UserID'),
                        orgid: vm.activityID
                    }
                    let res = await goldeggsids(data)
                    if (res.code == '200') {
                        if (res.data.length > 0) {
                            vm.huodongchangci = res.data
                            for (let i = 0; i < vm.huodongchangci.length; i++) {
                                if (vm.huodongchangci[i].org_id == vm.activityID) {
                                    vm.activatesource = vm.huodongchangci[i].org_name
                                    vm.activateid = vm.huodongchangci[i].activate_id
                                    const startDate = new Date(vm.huodongchangci[i].start_time);
                                    const endDate = new Date(vm.huodongchangci[i].end_time);
                                    const currentDate = new Date();
                                    if (currentDate >= startDate && currentDate <= endDate) {
                                        this.showactivity = true
                                        Axios.post('/gold/activate/ugetrecordlist', {
                                            params: {
                                                selecttj: 'gold_activate_record.user_id=' + Cookies.get("UserID"),
                                                ordertj: '',
                                                pageSize: 100,
                                                pageNum: 1,
                                                userid: Cookies.get("UserID"),
                                                activateid: vm.activateid
                                            }
                                        }, {
                                            headers: {
                                                "Content-Type": "application/json",
                                                token: Cookies.get('token')
                                            }
                                        }
                                        ).then(res => {
                                            if (res.status) {
                                                if (res.data.list.length > 0) {

                                                    vm.levels = res.data.list[0].level
                                                    vm.present_name = res.data.list[0].present_name
                                                    if (vm.levels == '4等奖') {
                                                        vm.ishuode = false
                                                    } else {
                                                        vm.ishuode = true
                                                    }
                                                    vm.newRecodePop = true; //显示中奖纪录
                                                } else {
                                                    vm.startTimer()
                                                    vm.newRecodePop = false; //显示中奖纪录
                                                }
                                            }
                                        }).catch(err => { });
                                    } else if (currentDate < startDate) {
                                        this.showzajindan = true
                                        // this.showactivity = false
                                        this.showstart = true
                                        vm.starttimekaishi = this.formatTimestamp(vm.huodongchangci[i].start_time)
                                        // return "未开始";
                                    } else {
                                        vm.showzajindan = true
                                        // vm.showactivity = false
                                        vm.showstart = false
                                        // return "已结束";
                                    }
                                } else {
                                    return vm.showzajindan = false
                                }
                            }
                        } else {
                            return vm.showzajindan = false
                        }
                    } else {
                        vm.$message({
                            message: res.msg,
                            type: 'error'
                        });
                        return vm.showzajindan = false

                    }

                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            formatTimestamp(timestamp) {
                const dateObj = new Date(timestamp);
                const month = (dateObj.getMonth() + 1).toString().padStart(2, '0');
                const day = dateObj.getDate().toString().padStart(2, '0');
                const time = timestamp.split(' ')[1];
                return `${month}-${day} ${time}`;
            },
            // 查询中奖记录
            getJindan() {
                Axios.post('/gold/activate/getrecordlist', {
                    params: {
                        selecttj: 'gold_activate_detail.level<4',
                        ordertj: '',
                        pageSize: 100,
                        pageNum: 1,
                        userid: Cookies.get('UserID'),
                    }
                }, {
                    headers: {
                        "Content-Type": "application/json",
                        token: Cookies.get('token')
                    }
                }
                ).then(res => {
                    let data = {
                        names: res.org_name
                    }
                    for (var i in res.data.list)
                        this.listname.push({
                            org_name: res.data.list[i].org_name,
                            level: res.data.list[i].level
                        })

                })
            },
            // 跳转到领取页面
            getWinning() {
                this.$router.push({ name: "myPrice" })
            },
            // 修改庆祝彩带方法
            startCelebration() {
                this.confettis = [];
                const colors = ['#ff6b6b', '#4ecdc4', '#ffd700', '#45b7d1'];

                for (let i = 0; i < this.confettiCount; i++) {
                    this.confettis.push({
                        style: {
                            backgroundColor: colors[Math.floor(Math.random() * colors.length)],
                            left: Math.random() * 100 + '%',
                            transform: `rotate(${Math.random() * 360}deg)`,
                            animation: `confetti-fall ${2 + Math.random() * 3}s ease-out infinite` // 改为无限循环
                        }
                    });
                }
            },
            // 是否集卡
            async getshowconsolidationcard() {
                let vm = this;
                let rp = JSON.parse(vm.$route.query.obj);
                let data = {
                    suplierid: rp.gid || rp.pubid
                };
                let res = await showconsolidationcard(data);
                console.log(res, 'res是否集卡');

                // 判断res.data是否为空对象
                if (res.code == '200') {
                    if (res.data && Object.keys(res.data).length > 0) {
                        // 如果res.data不是空对象
                        this.showjika = true
                        this.suppliercardName = res.data.cardName
                        this.cardimageUrl = res.data.imageUrl;
                        for (let i = 0; i < 4; i++) {
                            this.rotatingImages.push(res.data.imageUrl);
                        }
                        if (res.data.isCollected == 0) {
                            vm.startCountdown(res.data.pkid);  // 集卡倒计时
                        } else {
                            // 已经收集过了。
                            this.showjika = true
                            vm.isFirstTime = false
                            vm.isCompleted = true;
                        }
                    } else {
                        this.showjika = false
                        // 如果res.data是空对象
                        console.log('res.data是空对象');

                    }

                    console.log(res, 'ressss');
                }
            },
            startCountdown(pkid) {
                const timer = setInterval(() => {
                    if (this.remainingTime > 0) {
                        this.remainingTime--
                    } else {
                        clearInterval(timer)
                        this.isCompleted = true
                        this.showDialog(pkid)
                    }
                }, 1000)
            },
            async showDialog(pkids) {
                // 去告诉后端我集卡成功了!
                let data = {
                    cardId: pkids
                }
                let res = await cardcollectionsuccessful(data)
                if (res.code == '200') {
                    this.dialogVisible = true
                    this.$message({
                        message: '集卡成功',
                        type: 'success',
                        duration: 1500
                    });
                    if (this.isFirstTime) {
                        setTimeout(() => {
                            this.showFinalImage = true
                            this.isFirstTime = false
                        }, 3000)
                    } else {
                        this.showFinalImage = true
                    }
                } else if (res.code == '500') {
                    this.$message({
                        message: res.errorMsg,
                        type: 'info',
                        duration: 1500
                    });
                } else {

                }

            },
            handleCountdownClick() {
                if (this.isCompleted) {
                    this.isFirstTime = false
                    this.showFinalImage = true
                    this.dialogVisible = true
                }
            },
            gomycardcollecting() {
                if (Cookies.get('token')) {
                    const { href } = this.$router.resolve({
                        name: 'mycardcollecting',
                    });
                    window.open(href, '_blank');
                } else {
                    this.$router.push({ name: 'Login' });
                }
            },
            getCardStyle(index) {
                const colors = ['#ff6b6b', '#4ecdc4', '#45b7d1', '#96ceb4']
                return {
                    'animation-delay': `${index * 0.2}s`,
                    'border-color': colors[index]
                }
            },

        }
    };
</script>

<style lang='scss'>
    .supply_wrap2 {

        /* position: relative; */
        .search-box1 {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding: 0 15px 15px 15px;
            margin: 0 auto;
        }

        .suppldetaibox-top {
            width: 95%;
            margin: 25px auto;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .flex-container {
            display: flex;
            flex-wrap: wrap;
        }

        .flex-item {
            flex: 0 0 calc(8.14% - 10px);
            /* 每个元素占据约 7.14% 的宽度，减去间隔 */
            margin: 5px;
            /* 设置元素间隔 */
            text-align: center;
            /* 文字居中显示 */
            cursor: pointer;
            font-weight: 400;
            line-height: 30px;
            /* 鼠标指针样式为手型 */
        }

        .selected {
            background-color: lightblue;
            font-weight: 700;
            /* 设置选中样式，可以根据需要调整 */
        }

        .el-form-item__content {
            line-height: 30px !important;
            font-size: 14px;
        }

        .suppldetaibox {
            margin: 0 auto;
            width: 80%;
            /* height: 3000px; */
            background-color: #b82830;
        }

        .el-dropdown-link {
            cursor: pointer;
            color: #409EFF;
        }

        .el-icon-arrow-down {
            font-size: 12px;
        }

        .mySelect {
            width: 100px;
        }

        .search-wrap {
            background-color: #fff;
            position: relative;
            overflow: hidden;

            .drop_btn {
                position: absolute;
                display: block;
                line-height: 30px;
                padding: 0px 40px;
                cursor: pointer;
                bottom: 0px;
                right: 0px;
                color: #999;
            }

            .no-margin {
                margin: 0 !important;
            }

            /* .el-input {
            width: 192px;
        } */

            .el-input__inner {
                /* padding: 0px 8px; */
                height: 35px;
                /* width: 192px; */
            }

            .s-input {
                float: left;
                width: 75px;

                .el-form-item__content {
                    .midbox {
                        width: 52px;
                    }
                }

                .el-input__inner {
                    padding: 0px 8px;
                    width: 52px;
                }
            }

            .date-input {
                float: left;
                width: 130px;

                .el-input__inner {
                    padding: 0px 8px;
                    width: 128px;
                }
            }

            .el-input--prefix .el-input__inner {
                padding-left: 25px;
            }

            .line {
                text-align: center;
            }

            .s-input {
                .el-input {
                    width: 70%;
                }

                i {
                    font-style: normal;
                }
            }

            .el-form-item__label {
                padding-right: 5px;
                font-size: 12px;
            }

            .search-btn {
                text-align: center;
                padding-top: 15px;
            }

            //表单清除
            .labelwrap {
                position: relative;

                .circleclose {
                    display: none
                }

                .el-form-item__content:hover .circleclose {
                    position: absolute;
                    cursor: pointer;
                    top: 3px;
                    right: 0px;
                    height: 24px;
                    line-height: 24px;
                    width: 24px;
                    text-align: center;
                    color: #bcc0c5;
                    display: block;
                }
            }
        }

        /* 分类弹框样式 */
        .cont-sty {

            //学科、大众
            .el-col .treebox {
                width: 209px;
                height: 323px;
                padding: 15px 0 0 15px;
                padding-right: 0px;
                margin: 28px 0 0 38px;
                background-color: #fff;
                border-radius: 4px;
                border: solid 1px #c9d7e8;

                .search-sty {
                    .el-input__inner {
                        width: 200px;
                        height: 32px;
                        padding-left: 28px;
                        background-color: #fff;
                        border-radius: 16px;
                        height: 28px;
                        line-height: 28px;
                        border: solid 1px #b6d2e6;
                    }

                    .el-icon-search {
                        line-height: 32px;
                    }
                }

                .lefttree {
                    height: 291px;
                    overflow: auto;
                    list-style: none;

                    .check-box {
                        cursor: pointer;
                        margin-top: 10px;
                    }
                }

                .tit {
                    font-weight: bold;
                    font-size: 13px;
                }

                .right-tree {
                    width: 209px;
                    height: 301px;
                    overflow: auto;
                    list-style: none;
                    padding: 0px;

                    >li {
                        cursor: pointer;
                        margin-top: 10px;

                        span {
                            display: inline-block;
                            width: 170px;
                            font-size: 12px;
                        }

                        i {
                            font-size: 17px;
                            color: #bbc8d4;
                        }

                        &:hover i {
                            color: #1c7bd3;
                        }
                    }

                    >li:hover {
                        color: #1c7bd3;
                    }
                }

                .noData {
                    text-align: center;
                    font-size: 12px;

                    img {
                        height: 90px;
                        width: 70px;
                        margin: 30px auto 15px;
                        display: block;
                    }

                    .p {
                        margin: 4px;
                    }
                }

            }
        }

        .clearbtn {
            float: right;
            margin-right: 18px;
            width: 47px;
            height: 22px;
            line-height: 22px;
            background-color: #ffeaea;
            border-radius: 2px;
            border: 1px solid #f2c3c3;
            color: #ce4747;
        }

        .btnbase {
            border: 0px;
            // border-radius: 50px;
            font-weight: bold;
            font-size: 12px;
            cursor: pointer;
            // padding:0 24px;
            display: inline-block;
            height: 33px;
            line-height: 33px;
            margin: 8px 12px;
            width: 70px;
            background-color: #deefff;
            border-radius: 4px;
        }

        .btn_box {
            //按钮样式
            text-align: center;
            margin-top: 15px;

            .btn_sure {
                @extend .btnbase;
                color: #fff;
                background-color: #2c88f4;
            }

            .btn_canle {
                @extend .btnbase;
                color: #2c88f4;
                background-color: #deefff;
            }

            .btn_green {
                @extend .btnbase;
                color: #fff;
                background-color: #67c23a;
            }
        }



        .zjd {
            margin: 30px auto;
            height: 700px;
            position: relative;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .zjdBg {
            /* 
    position: fixed;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    // background: rgba(235, 228, 228 / 80%);
    z-index: 100;
    overflow-y: hidden; */

            .zjdContent {
                height: 100%;
                color: #fff;

                .supplier {
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background-color: cadetblue;
                }

                .nextTime {
                    height: 40px;
                    line-height: 40px;
                    text-align: center;
                    background-color: #fb7d0f;
                }

                .activityContent {
                    // display: flex;
                    height: 100%;

                    .Sessions {
                        width: 100%;
                        height: 100%;
                        line-height: 50px;
                        text-align: center;
                        // background-color: aquamarine;
                    }
                }
            }
        }

        .zjdClose {
            position: absolute;
            width: 30px;
            height: 30px;
            top: 20px;
            right: 20px;
            cursor: pointer;
            z-index: 109;

            img {
                width: 30px;
                height: 30px;
            }
        }

        .zjdBox {
            width: 420px;
            height: 520px;
            position: absolute;
            left: 50%;
            transform: translate(-50%, 0);
        }

        .Sign {
            height: 300px;
            text-align: center;
            display: flex;
            padding: 0;
            flex-direction: column;
            justify-content: space-around;
            color: #000;

            .success {
                font-size: 22px;
            }

            .continuity {
                font-size: 25px;
            }

            .el-button {
                margin-bottom: 50px;
            }

            p {
                text-align: left;
                display: flex;
                justify-content: center;
            }
        }

        .zjdGet {
            position: fixed;
            top: 20px;
            left: 20px;
            background: rgba(0, 0, 0, 0.3);
            width: 90px;
            // height: 120px;
            text-align: center;
            cursor: pointer;
            z-index: 99;
        }

        .zjdimg img {
            width: 60px;
        }

        .zjdtext {
            color: #fff;
            font-size: 12px;
            line-height: 30px;

            >b {
                font-weight: normal;
            }
        }

        .TopComStyle {
            position: relative;
            height: 60px;
            width: 100%;
            background-color: rgba(255, 255, 255, 1);
            box-shadow: undefined, inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);

            .el-dropdown {
                cursor: pointer;
            }
        }

        .topContainer {
            width: 1200px;
            height: 100%;
            margin: 0px auto;
            display: flex;
            align-items: center;
            justify-content: space-between;
            color: white;
        }

        /* 1 */
        .topConLeft {
            display: flex;
            align-items: center;
            justify-content: space-around;
            font-size: 17px;
            cursor: pointer;
        }

        .topConLeft img {
            width: 150px;
            height: 55px;
        }

        .topConLeft span {
            cursor: pointer;
            color: #666;
            font-size: 16px;
            margin-left: 25px;
            padding: 0px 3px;
            line-height: 30px;
        }

        .topConLeft span.cur {
            // color: #fb7d0f;
            border-bottom: 3px solid #fb7d0f;
        }

        /* 2 */
        .el-input {
            /* width: 250px; */
            text-align: left;
            font-family: PingFangSC-Regular;
        }

        .topContainer>>>.el-input__inner {
            color: rgba(0, 0, 0, 0.25);
            font-size: 14px;
        }

        /* 3 */
        .TopConRight {
            color: black;
            color: rgba(102, 102, 102, 1);
            font-size: 14px;
        }

        .TopConRight>span {
            margin-left: 15px;
        }

        .q {
            width: 100%;
            display: flex;
            justify-content: space-between;

            .r {
                margin: 0 auto;
            }

            .r div {
                width: 375px;
                height: 50px;
                line-height: 50px;
                text-align: center;
                background-color: yellowgreen;
                border: 1px solid #000;
                font-size: 20px;
            }

            // .zjdBox {
            //     width: 500px;

            //     background-color: #fff;
            // }

            .hdcc {
                width: 150px;
                height: 30px;
                background-color: #63000f;
                border-radius: 30px;
                line-height: 30px;
                text-align: center;
                margin: 0 auto;
            }

            .prInfo {
                position: absolute;
                top: 80px;
                right: 35px;
                width: 330px;
                height: 430px;
                background-color: #fff;
                border-radius: 10px;
            }

            .prInfo-box {
                width: 100%;
                height: 50px;
                display: flex;
                justify-content: center;
                align-items: center;
                border-top-left-radius: 10px;
                border-top-right-radius: 10px;
                background-color: #63000f;
            }



            .prInfo-info {
                width: 150px;
                height: 30px;
                background-color: #63000f;
                border-radius: 30px;
                margin: 10px auto;
                line-height: 30px;
                text-align: center;

            }

            .notice {
                width: 270px;
                height: 300px;
                border-radius: 8px;
                // border: 1px solid #eee;

            }

            .notice__inner {
                width: 100%;
                height: 100%;
                overflow: hidden;
                font-size: 14px;
                color: #999;
            }

            .notice__box {
                animation: roll 2s linear infinite;
            }

            .notice__item {
                width: 100%;
                height: 100px;
                line-height: 100px;
                padding: 0 12px;
                overflow: hidden;
                text-align: center;
                white-space: nowrap;
            }

            @keyframes roll {
                0% {
                    transform: translatey(0);
                }

                100% {
                    transform: translatey(-300px);
                }
            }

            .zjdtime {
                font-size: 24px;
                position: absolute;
                top: 0;
                left: 0;
            }

            .hdcc1 {
                width: 300px;
                height: 400px;
                background-color: pink;
                position: absolute;
                top: 80px;
                left: 35px;
            }

            .hdcc1 div {
                width: 342px;
                height: 40px;
                border: 1px solid #fff;
                line-height: 40px;
                text-align: center;
            }




            .lottery-alerth1 {
                font-size: 20px;
                font-weight: 400;
                color: #000;
                position: relative;
                // margin-top: 20px;
            }

            .zjdContainer {
                font-family: Avenir, Helvetica, Arial, sans-serif;
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;
                text-align: center;
                color: #666;
                background-color: #bd2a33;
                height: 100%;
                width: 100%;
            }

            .zjdtitle {
                position: absolute;
                top: 20px;
                width: 100%;
                text-align: center;
            }

            .myprize {
                -moz-border-radius: 20px;
                border-radius: 20px;
                padding: 8px 20px;
                color: #edd251;
                font-weight: bold;
                font-size: 18px;

                margin: auto;
                // background: #fff;
            }

            .myprizeimg {
                width: 260px;
                height: 260px;
                background-color: pink;
                display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                left: 120px;
                bottom: 90px;

                img {
                    width: 100%;
                    height: 100%;
                }
            }

            .myprizetitle {
                position: absolute;
                bottom: 45px;
                left: -5%;
                width: 150px;
                height: 30px;
                border-radius: 30px;
                border: 1px solid #999;
                text-align: center;
                line-height: 30px;
                margin-left: 200px;
            }

            .linqu {
                position: absolute;
                bottom: 0;
                left: 37%;
                width: 100px;
                height: 30px;
                border-radius: 30px;
                border: 1px solid #999;
                text-align: center;
                line-height: 30px;
                margin-bottom: 1px;
                cursor: pointer;
            }

            .nostate {
                width: 500px;
                height: 100px;
                // border: 1px solid #fff;
                line-height: 100px;
                text-align: center;
                font-size: 38px;
                position: absolute;
                left: 30%;
                top: 36%;
            }

        }


        ul {
            list-style: none;
        }

        a img {
            border: none;
        }

        a {
            color: #333;
            text-decoration: none;
        }

        a:hover {
            color: #ff0000;
        }

        #mooc {
            width: 399px;
            border: 5px solid #ababab;
            border-radius: 15px;
            box-shadow: 2px 2px 10px #ababab;
            margin: 50px auto 0;
            text-align: left;
            height: 300px;
            /* 增加整体高度 */
        }

        #moocTitle {
            height: 62px;
            overflow: hidden;
            font-size: 26px;
            line-height: 62px;
            padding-left: 30px;
            background-image: linear-gradient(top, #f05e6f, #c9394a);
            border: 1px solid #f05e6f;
            border-radius: 8px 8px 0 0;
            color: #fff;
            position: relative;
        }

        #moocTitle a {
            position: absolute;
            right: 10px;
            bottom: 10px;
            display: inline;
            color: #fff;
            font-size: 12px;
            line-height: 24px;
        }

        #moocBox {
            height: 335px;
            /* 增加内容区域高度 */
            margin-top: 15px;
            overflow: hidden;
            height: 360px;
            margin-left: 10px;
            margin-right: 10px;

        }

        #mooc ul li {
            height: 40px;
            /* 增加单行高度 */
            line-height: 40px;
            /* 设置行高 */
        }

        #mooc ul li a {
            width: 180px;
            float: left;
            display: block;
            overflow: hidden;
            text-indent: 15px;
            height: 40px;
        }

        #mooc ul li span {
            float: right;
            color: #999;
        }

        .bottxtx {
            font-size: 16px;
            display: block !important;
            /* margin-left: 4%; */
            text-align: center;
            color: #63000f;
            font-weight: 700;
        }

        @keyframes jump {

            0%,
            100% {
                transform: translateY(0);
            }

            50% {
                transform: translateY(-8px);
            }
        }

        .jump-text {
            display: inline-block;
            animation: jump 2s infinite;
            color: #FFD700;
        }

        .countdown {
            position: fixed;
            top: 40%;
            left: 1%;
            font-size: 1.8em;
            color: #ffffff;
            background: linear-gradient(45deg, #ff6b6b, #ff8e53);
            padding: 5px 10px;
            border-radius: 10px;
            box-shadow: 0 0 20px rgba(255, 107, 107, 0.5);
            cursor: pointer;
            z-index: 1000;
        }

        .success-badge {
            animation: rainbow1 2s infinite;
            font-weight: bold;
            padding: 10px;
        }

        .swing1-animation {
            animation: swing1 2s ease-in-out infinite;
        }

        @keyframes swing1 {

            0%,
            100% {
                transform: rotate(-1deg);
            }

            50% {
                transform: rotate(1deg);
            }
        }

        @keyframes rainbow1 {
            0% {
                color: #ff6b6b;
            }

            25% {
                color: #4ecdc4;
            }

            50% {
                color: #45b7d1;
            }

            75% {
                color: #96ceb4;
            }

            100% {
                color: #ff6b6b;
            }
        }

        .card-icon {
            font-size: .8em;
            margin-bottom: 5px;
            animation: bounce1 1s infinite alternate;
        }

        @keyframes bounce1 {
            0% {
                transform: translateY(0);
            }

            100% {
                transform: translateY(-10px);
            }
        }

        .timer-text {
            font-size: 1em;
            font-weight: bold;
        }

        .collecting-text {
            font-size: .5em;
            color: #fff;
            opacity: 0.8;
            margin-top: 5px;
            animation: pulse1 1.5s infinite ease-in-out;
        }

        @keyframes pulse1 {
            0% {
                opacity: 0.8;
            }

            50% {
                opacity: 1;
            }

            100% {
                opacity: 0.8;
            }
        }

        /* 为倒计时添加更多视觉效果 */
        .timer {
            position: relative;
            padding: 10px;
            /* background: radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, rgba(255, 107, 107, 0.6) 100%); */
            border-radius: 15px;
            box-shadow: 0 0 10px rgba(255, 107, 107, 0.5);
            width: 172px;
            text-align: center;
        }

        /* 自定义按钮风格 */
        .countdown:hover {
            box-shadow: 0 0 30px rgba(255, 107, 107, 0.7);
        }

        @keyframes glow1 {

            0%,
            100% {
                opacity: 0.8;
            }

            50% {
                opacity: 0.4;
            }
        }

        .card-container {
            padding: 30px 0;
            /* 增加内边距 */
            margin: 20px 0;
            position: relative;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 300px;
        }

        .rotating-card {
            position: absolute;
            width: 150px;
            height: 200px;
            border: 3px solid;
            border-radius: 15px;
            animation: rotate1 3s ease-out forwards;
            transform-origin: center;
            box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
            margin-top: 50px;
        }

        @keyframes rotate1 {
            0% {
                transform: rotate(0deg) scale(1);
                opacity: 1;
            }

            50% {
                transform: rotate(180deg) scale(1.2);
                opacity: 0.8;
            }

            100% {
                transform: rotate(360deg) scale(0);
                opacity: 0;
            }
        }

        .final-card {
            width: 200px;
            height: 280px;
            animation: popIn1 0.5s ease-out;
            border: 5px solid gold;
            border-radius: 20px;
            box-shadow: 0 0 30px rgba(255, 215, 0, 0.5);
            margin-top: 50px;
        }

        @keyframes popIn1 {
            0% {
                transform: scale(0);
            }

            80% {
                transform: scale(1.1);
            }

            100% {
                transform: scale(1);
            }
        }

        .congratulations-text {
            width: 100%;
            margin: 25px 0;
            /* 加大文字间距 */
            padding: 15px 25px;
            /* 增加文字内边距 */
            text-align: center;
            font-size: 1.5em;
            color: #ff6b6b;
            margin-top: 20px;
            animation: textGlow1 1.5s ease-in-out infinite;
        }

        @keyframes textGlow1 {
            50% {
                text-shadow: 0 0 10px #ff8e53;
            }
        }

        /* 自定义弹窗样式 */
        /* /deep/ .card-dialog { 
    background: rgba(255, 255, 255, 0.95);
    border-radius: 20px;
    border: 3px solid #ff6b6b;
    box-shadow: 0 0 40px rgba(255, 107, 107, 0.3);
  } */
        /* 新增样式 */
        .dialog-mask {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            z-index: 2000;
            display: flex;
            justify-content: center;
            align-items: flex-start;
            /* 保持顶部距离 */
            padding-top: 10vh;
        }

        .custom-dialog {
            width: 45%;
            background: rgba(0, 0, 0, 0.85);
            border-radius: 20px;
            backdrop-filter: blur(5px);
            box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        }

        .dialog-header {
            background: linear-gradient(45deg, #ff6b6b, #ff8e53);
            border-radius: 15px 15px 0 0;
            padding: 20px;
            position: relative;
        }

        .dialog-title {
            color: white;
            font-size: 1.2em;
            display: block;
            text-align: center;
            text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
        }

        .dialog-body {
            padding: 20px;
            background-color: #000;
            border-radius: 0 0 20px 20px;
        }

        .close-btn {
            position: absolute;
            right: 15px;
            top: 50%;
            transform: translateY(-50%);
            color: white;
            font-size: 24px;
            cursor: pointer;
            background: transparent;
            border: none;
            transition: opacity 0.3s;
        }

        .close-btn:hover {
            opacity: 0.8;
        }

        @keyframes twinkle {

            0%,
            100% {
                opacity: 0.3;
            }

            50% {
                opacity: 1;
            }
        }

        .confetti {
            position: absolute;
            width: 96%;
            height: 20px;
            /* 高度为10px的粒子排列在一行中，稍微调整以确保每行只有一颗 */
            display: flex;
            justify-content: space-between;
            /* 使粒子在水平方向上整齐排列 */
            align-items: center;
            pointer-events: none;
        }

        .confetti-piece {
            width: 10px;
            /* 每颗彩带粒子的大小为10px */
            height: 10px;
            /* 高度为10px */
            background-color: #ff6b6b;
            /* 默认的彩带颜色，可以后面通过JS动态修改 */
            clip-path: polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%);
            /* 保持原来的形状 */
            animation: confetti-fall1 3s ease-out infinite;
            /* 保持之前的下落动画 */
        }

        @keyframes confetti-fall1 {
            0% {
                transform: translateY(-100vh) rotate(0deg);
                opacity: 1;
            }

            100% {
                transform: translateY(100vh) rotate(720deg);
                opacity: 0;
            }
        }

        /* 卡片发光效果 */
        .final-card {
            border: 3px solid rgba(255, 215, 0, 0.5);
            box-shadow:
                0 0 30px rgba(255, 215, 0, 0.3),
                0 0 60px rgba(255, 107, 107, 0.2);
            animation: glow1Pulse1 2s ease-in-out infinite;
            margin: 20px auto;
            /* 增加外边距 */
        }

        @keyframes glow1Pulse1 {

            0%,
            100% {
                filter: brightness(1);
                box-shadow: 0 0 30px rgba(255, 215, 0, 0.3);
            }

            50% {
                filter: brightness(1.2);
                box-shadow: 0 0 50px rgba(255, 107, 107, 0.4);
            }
        }

        @keyframes float {

            0%,
            100% {
                transform: translateY(0) rotateX(0deg) rotateY(0deg);
            }

            50% {
                transform: translateY(-20px) rotateX(5deg) rotateY(5deg);
            }
        }

        /* 新增光晕效果 */
        .card-container::after {
            content: '';
            position: absolute;
            width: 100%;
            height: 130%;
            background: radial-gradient(circle,
                    rgba(255, 215, 0, 0.4) 0%,
                    rgba(255, 107, 107, 0.2) 30%,
                    transparent 70%);
            animation: glow1 4s linear infinite;
            filter: brightness(1.2);
            /* 增强光晕可见度 */
        }

        @keyframes glow1 {

            0%,
            100% {
                opacity: 0.8;
            }

            50% {
                opacity: 0.4;
            }
        }

        /* 修改彩带样式 */
        .confetti-piece {
            animation: confetti-fall1 3s ease-out infinite;
            /* 永久动画 */
        }

        /* 调整集卡容器间距 */
        .card-container {
            margin-top: 40px;
            /* 增加与彩带的间距 */
            position: relative;
            z-index: 1;
        }

        /* 新增光感效果 */
        .congratulations-text {
            position: relative;
            overflow: hidden;
            padding: 15px 0;
        }

        .light-bar {
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg,
                    transparent 0%,
                    rgba(255, 255, 255, 0.5) 50%,
                    transparent 100%);
            animation: lightFlow1 1.5s ease-in-out infinite;
        }

        @keyframes lightFlow1 {
            0% {
                left: -100%;
            }

            100% {
                left: 100%;
            }
        }

        /* 增强原有文字效果 */
        .congratulations-text {
            font-size: 24px;
            background: linear-gradient(90deg, #ff6b6b, #ff8e53, #ffd700);
            -webkit-background-clip: text;
            color: transparent;
            position: relative;
            padding: 10px 20px;
            border-radius: 8px;
            overflow: visible;
        }

        .congratulations-text::after {
            content: '';
            position: absolute;
            top: -2px;
            left: -2px;
            right: -2px;
            bottom: -2px;
            background: inherit;
            filter: blur(10px);
            z-index: -1;
        }

        .light-bar {
            background: linear-gradient(90deg,
                    transparent 0%,
                    rgba(255, 255, 255, 0.8) 50%,
                    transparent 100%);
        }

        /* 调整流动速度 */
        animation: lightFlow 2s ease-in-out infinite;

        /* 改变渐变角度 */
        background: linear-gradient(45deg, #ff6b6b, #ffd700);

        .congratulations-text {
            position: relative;
            display: inline-block;
            font-size: 24px;
        }

        .text-with-light {
            position: relative;
            color: #ff6b6b;
            background: linear-gradient(90deg, #ff6b6b, #ff8e53, #ffd700);
            -webkit-background-clip: text;
            background-clip: text;
            -webkit-text-fill-color: transparent;
            padding: 0 10px;
        }

        .text-with-light::after {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 60%;
            height: 100%;
            background: linear-gradient(90deg,
                    rgba(255, 255, 255, 0) 0%,
                    rgba(255, 255, 255, 0.4) 50%,
                    rgba(255, 255, 255, 0) 100%);
            transform: skewX(-10deg);
            animation: textLight 2s ease-in-out infinite;
        }

        @keyframes textLight {
            0% {
                left: -10%;
                opacity: 0.8;
            }

            70% {
                opacity: 0.6;
            }

            100% {
                left: 45%;
                opacity: 0;
            }
        }

        /* 增加文字阴影增强立体感 */
        .text-with-light {
            text-shadow:
                0 2px 4px rgba(255, 107, 107, 0.3),
                0 4px 12px rgba(255, 142, 83, 0.2);
        }

        /* 添加集卡记录样式 */
        .collection-record {
            background: rgba(255, 255, 255, 0.1);
            /* 更透明的背景 */
            margin-top: 10px;
            padding: 5px 5px;
            border-radius: 8px;
            display: flex;
            align-items: center;
            animation: slideIn1 0.5s ease-out;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            border: 1px solid rgba(255, 255, 255, 0.2);
        }

        .record-icon {
            font-size: 1.2em;
            margin-right: 10px;
            animation: iconFloat1 1.5s ease-in-out infinite;
        }

        .record-text {
            font-size: 0.8em;
            color: #fff;
            text-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
        }

        /* 新增动画 */
        @keyframes slideIn1 {
            from {
                opacity: 0;
                transform: translateY(10px);
            }

            to {
                opacity: 1;
                transform: translateY(0);
            }
        }

        @keyframes iconFloat1 {

            0%,
            100% {
                transform: translateY(0) rotate(-1deg);
            }

            50% {
                transform: translateY(-5px) rotate(1deg);
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/SearchComponentcopy.vue